import React from "react";
import Table from "./table";
import { RatingRow } from "./types";

export const RankingTable: React.FC<{ rows: RatingRow[] }>= ({ rows }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>Player</th>
        <th>Rating</th>
        <th>W</th>
        <th>L</th>
        <th>W/L</th>
      </tr>
    </thead>
    <tbody>
      {rows.map((r, i) => (
        <tr key={r.player.id}>
          <td>{i + 1}</td>
          <td>{r.player.name}</td>
          <td>{Math.round(r.rating)}</td>
          <td>{r.wins}</td>
          <td>{r.losses}</td>
          <td>{r.losses === 0 ? "—" : (r.wins / r.losses).toFixed(2)}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default RankingTable;


